<template>
  <div>
    <form>
      <b-row :class="saving_params.is_poli_gigi ? 'mb-50' : 'mb-75'">
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">
              Tinggi Badan <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
            </strong>
            <br />
            <template>
              <b-input-group>
                <template #append>
                  <b-input-group-text>cm</b-input-group-text>
                </template>
                <b-form-input
                  @keypress="checkInputSpecial"
                  type="text"
                  id="tinggi_badan"
                  :value="pasien.tinggi_badan != null && pasien.tinggi_badan != '' ? pasien.tinggi_badan.toString().replace(',','.') : ''"
                  @input="updateData({key: 'tinggi_badan', value: $event})"
                />
              </b-input-group>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">
              Berat Badan <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
            </strong>
            <br />
            <template>
              <b-input-group>
                <template #append>
                  <b-input-group-text>kg</b-input-group-text>
                </template>
                <b-form-input
                  @keypress="checkInputSpecial"
                  type="text"
                  id="berat_badan"
                  :value="pasien.berat_badan != null && pasien.berat_badan != '' ? pasien.berat_badan.toString().replace(',','.') : ''"
                  @input="updateData({key: 'berat_badan', value: $event})"
                />
              </b-input-group>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">
              Suhu
            </strong>
            <br />
            <template>
              <b-input-group>
                <template #append>
                  <b-input-group-text>C</b-input-group-text>
                </template>
                <b-form-input
                  @keypress="checkInputSpecial"
                  type="text"
                  id="suhu"
                  :value="pasien.suhu != null && pasien.suhu != '' ? pasien.suhu.toString().replace(',','.') : ''"
                  @input="updateData({key: 'suhu', value: $event})"
                />
              </b-input-group>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">
              Sistole <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
            </strong>
            <br />
            <template>
              <b-input-group>
                <template #append>
                  <b-input-group-text>mmHg</b-input-group-text>
                </template>
                <b-form-input
                  @keypress="checkInput"
                  type="text"
                  id="tensi_sistole"
                  :value="pasien.tensi_sistole || ''"
                  @input="updateData({key: 'tensi_sistole', value: $event})"
                />
              </b-input-group>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">
              Diastole <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
            </strong>
            <br />
            <template>
              <b-input-group>
                <template #append>
                  <b-input-group-text>mmHg</b-input-group-text>
                </template>
                <b-form-input
                  @keypress="checkInput"
                  type="text"
                  id="tensi_diastole"
                  :value="pasien.tensi_diastole || ''"
                  @input="updateData({key: 'tensi_diastole', value: $event})"
                />
              </b-input-group>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">
              Nadi <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
            </strong>
            <br />
            <template>
              <b-input-group>
                <template #append>
                  <b-input-group-text>x / menit</b-input-group-text>
                </template>
                <b-form-input
                  @keypress="checkInput"
                  type="text"
                  id="nadi"
                  :value="pasien.nadi || ''"
                  @input="updateData({key: 'nadi', value: $event})"
                />
              </b-input-group>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">
              Respirasi <label v-if="saving_params.is_bpjs" style="color:red"> *</label>
            </strong>
            <br />
            <template>
              <b-input-group>
                <template #append>
                  <b-input-group-text>x / menit</b-input-group-text>
                </template>
                <b-form-input
                  @keypress="checkInput"
                  type="text"
                  id="respirasi"
                  :value="pasien.respirasi || ''"
                  @input="updateData({key: 'respirasi', value: $event})"
                />
              </b-input-group>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">
              Lingkar Perut
            </strong>
            <br />
            <template>
              <b-input-group>
                <template #append>
                  <b-input-group-text>cm</b-input-group-text>
                </template>
                <b-form-input
                  @keypress="checkInput"
                  type="text"
                  id="lingkar_perut"
                  :value="pasien.lingkar_perut || ''"
                  @input="updateData({key: 'lingkar_perut', value: $event})"
                />
              </b-input-group>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">
              IMT
            </strong>
            <br />
            <template>
              <b-input-group>
                <template #append>
                  <b-input-group-text>kg/m2</b-input-group-text>
                </template>
                <b-form-input
                  :readonly="true"
                  type="text"
                  id="imt"
                  :value="imt"
                />
              </b-input-group>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">SpO2</strong>
            <br />
            <template>
              <b-input-group>
                <template #append>
                  <b-input-group-text>%</b-input-group-text>
                </template>
                <b-form-input
                  @keypress="checkInput"
                  type="text"
                  id="saturasi_oksigen"
                  :value="pasien.saturasi_oksigen != null && pasien.saturasi_oksigen != '' ? pasien.saturasi_oksigen.toString().replace(',','.') : ''"
                  @input="updateData({key: 'saturasi_oksigen', value: $event})"
                />
              </b-input-group>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3" v-show="saving_params.is_poli_gigi">
          <b-form-group style="position: relative">
            <strong class="text-grey">Golongan Darah</strong>
            <br />
            <template>
              <vue-select
                :options="option_blood"
                placeholder="Pilih Gol. Darah"
                v-model="selectedBlood"
                class="__form-select"
                @input="updateData({key: 'golongan_darah', value: $event})"
              >
              </vue-select>
            </template>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mb-25" v-if="saving_params.is_poli_gigi">
        <b-col sm="12">
          <p class="h5 mb-4" style="color: grey;">Riwayat Kesehatan</p>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">Penyakit Jantung</strong>
            <br />
            <template>
              <vue-select
                :options="option_penyakit"
                placeholder="Pilih"
                v-model="riwayatPenyakit['penyakit_jantung']"
                class="__form-select"
                @input="updateData({key: 'penyakit_jantung', value: $event})"
              >
              </vue-select>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">Diabetes</strong>
            <br />
            <template>
              <vue-select
                :options="option_penyakit"
                placeholder="Pilih"
                v-model="riwayatPenyakit['diabetes']"
                class="__form-select"
                @input="updateData({key: 'diabetes', value: $event})"
              >
              </vue-select>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">Haemopilia</strong>
            <br />
            <template>
              <vue-select
                :options="option_penyakit"
                placeholder="Pilih"
                v-model="riwayatPenyakit['haemopilia']"
                class="__form-select"
                @input="updateData({key: 'haemopilia', value: $event})"
              >
              </vue-select>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">Hepatitis</strong>
            <br />
            <template>
              <vue-select
                :options="option_penyakit"
                placeholder="Pilih"
                v-model="riwayatPenyakit['hepatitis']"
                class="__form-select"
                @input="updateData({key: 'hepatitis', value: $event})"
              >
              </vue-select>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">Gastring</strong>
            <br />
            <template>
              <vue-select
                :options="option_penyakit"
                placeholder="Pilih"
                v-model="riwayatPenyakit['gastring']"
                class="__form-select"
                @input="updateData({key: 'gastring', value: $event})"
              >
              </vue-select>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <strong class="text-grey">Penyakit Lainnya</strong>
            <br />
            <template>
              <vue-select
                :options="option_penyakit"
                placeholder="Pilih"
                v-model="riwayatPenyakit['penyakit_lainnya']"
                class="__form-select"
                @input="updateData({key: 'penyakit_lainnya', value: $event})"
              >
              </vue-select>
            </template>
          </b-form-group>
        </b-col>
        <b-col sm="4" lg="3">
          <b-form-group style="position: relative">
            <br />
            <template>
              <b-form-input
                type="text"
                v-model.lazy="riwayatPenyakit['ket_penyakit_lainnya']"
                @input="updateData({key: 'ket_penyakit_lainnya', value: $event})"
                :disabled="!riwayatPenyakit['penyakit_lainnya'] || (riwayatPenyakit['penyakit_lainnya'] && riwayatPenyakit['penyakit_lainnya'].value != 'Y')"
              />
              <b-form-invalid-feedback
                style="text-transform: none"
                :state="isErrorKet"
              >
                Kolom harus diisi
              </b-form-invalid-feedback>
            </template>
          </b-form-group>
        </b-col>
      </b-row>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    'vue-select': () => import("@/components/VueSelectClearable.vue"),
  },
  data: () => ({
    imt: 0,
    option_blood: [
      { label: 'A', value: 'A' },
      { label: 'AB', value: 'AB' },
      { label: 'B', value: 'B' },
      { label: 'O', value: 'O' },
      { label: 'Tidak Diketahui', value: 'N' },
    ],
    option_penyakit: [
      { label: 'Tidak Ada', value: 'T' },
      { label: 'Ada', value: 'Y' }
    ],
    selectedBlood: null,
    riwayatPenyakit: {
      penyakit_jantung: null,
      diabetes: null,
      haemopilia: null,
      hepatitis: null,
      gastring: null,
      penyakit_lainnya: null,
      ket_penyakit_lainnya: null,
    },
    isErrorKet: true,
  }),
  name: "Anamnesa",
  computed: mapGetters(["pasien", "saving_params", "trx"]),
  mounted() {
    this.imt = this.pasien.imt;
    this.selectedBlood = this.option_blood.find(b => b.value == this.pasien.golongan_darah);
    this.setRiwayatKesehatan(this.trx.diagnosa);
  },
  watch: {
    "pasien.tinggi_badan": function(newVal, oldVal) {
      this.updateIMT({...this.pasien, tinggi_badan: newVal});
    },
    "pasien.berat_badan": function(newVal, oldVal) {
      this.updateIMT({...this.pasien, berat_badan: newVal});
    },
    "pasien.golongan_darah": function() {
      this.selectedBlood = this.option_blood.find(b => b.value == this.pasien.golongan_darah);
    },
    "trx.diagnosa": function() {
      this.setRiwayatKesehatan(this.trx.diagnosa);
    },
  },
  methods: {
    ...mapActions(["updateTandaVital", "updatePasien"]),
    checkInput($event) {
      const { key } = $event;
      var evt = $event;
      evt = evt ? evt : window.event;
      if (/[^0-9]/.test(key)) {
        evt.preventDefault();
      }
    },
    checkInputSpecial($event) {
      const { key } = $event;
      var evt = $event;
      evt = evt ? evt : window.event;
      if (/[^0-9.,]/.test(key)) {
        evt.preventDefault();
      }
    },
    updateIMT(data) {
      if (parseInt(data.tinggi_badan) && parseInt(data.berat_badan)) {
        let tinggi_badan = parseInt(data.tinggi_badan) * 0.01;
        let newImt = parseInt(data.berat_badan) / (tinggi_badan * tinggi_badan);
        this.imt = newImt.toFixed(2);
        this.updateTandaVital({key: 'imt', value: this.imt});
      } else {
        this.imt = null;
        this.updateTandaVital({key: 'imt', value: null});
      }
    },
    updateData(data) {
      if (data.key == 'tinggi_badan') {
        this.updatePasien({
          data: {...this.pasien, tinggi_badan: data.value}
        });
      }
      if (data.key == 'berat_badan') {
        this.updatePasien({
          data: {...this.pasien, berat_badan: data.value}
        });
      }

      let obj = ['golongan_darah','penyakit_jantung','diabetes','haemopilia','hepatitis','gastring','penyakit_lainnya'];
      this.isErrorKet = true;
      if (obj.includes(data.key) && data.value && typeof data.value == 'object') {
        data.value = data.value.value;
      }

      if (data.key == 'penyakit_lainnya') {
        if (data.value && data.value == 'Y') {
          this.isErrorKet = this.setValidationValue(this.riwayatPenyakit['ket_penyakit_lainnya']);
        } else {
          this.riwayatPenyakit['ket_penyakit_lainnya'] = null;
          this.updateTandaVital({key: 'ket_penyakit_lainnya', value: null});
        }
      }
      this.updateTandaVital(data);
    },
    setValidationValue( value) {
      if (!value || value == null || value == '' || value == undefined) {
        return false;
      } else {
        return true;
      }
    },
    setRiwayatKesehatan(data) {
      if (data && this.saving_params.is_poli_gigi) {
        Object.keys(this.riwayatPenyakit).forEach(v => {
          let val = null;
          if (data.hasOwnProperty(v) && data[v]) val = data[v];

          if (v == 'ket_penyakit_lainnya') this.riwayatPenyakit[v] = val;
          else this.riwayatPenyakit[v] = this.option_penyakit.find(op => op.value == val);

          this.updateTandaVital({key: v, value: val});
        });
      }
    },
  },
};
</script>

<style>
  .__form-select
    .vs__dropdown-toggle
    .vs__selected-options
    .vs__search::placeholder {
    color: #d1d2db !important;
    font-size: 14px !important;
    font-weight: 500;
  }
  .mb-25 {
    margin-bottom: 2.5rem !important;
  }
  .mb-50 {
    margin-bottom: 5rem !important;
  }
  .mb-75 {
    margin-bottom: 7.5rem !important;
  }
  .text-grey {
    font-size : 13px;
    color: grey;
  }
</style>